var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M493.235 289.941L447.647 335.529V400C447.647 426.51 426.157 448 399.647 448H335.177L289.589 493.588C270.843 512.332 240.452 512.332 221.706 493.588L176.118 448H111.647C85.138 448 63.647 426.51 63.647 400V335.529L18.06 289.941C-0.687 271.195 -0.687 240.803 18.06 222.059L63.647 176.471V112C63.647 85.49 85.138 64 111.647 64H176.118L221.706 18.412C240.452 -0.334 270.843 -0.334 289.589 18.412L335.177 64H399.647C426.157 64 447.647 85.49 447.647 112V176.471L493.235 222.059C511.981 240.803 511.981 271.195 493.235 289.941Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeal);
export default __webpack_public_path__ + "static/media/seal.3b0a841b677a6fde962a38bb0f469c09.svg";
export { ForwardRef as ReactComponent };